export default __webpack_public_path__ + "static/media/TokiRGB_violet.1da500c8.png";